import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Controller, Post, Body } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import {MachinesRequisitionService } from "./mechines-requisition.service";
import { machinesRequisitionIdReq } from "./dto/machines-req-data-req.dto";

@ApiTags('MachinesRequisituionController')
@Controller('machines_requisituion_controller')
export class MachinesRequisituionController {
    
    constructor(private machinesReqService: MachinesRequisitionService, 
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/create')
    async create(@Body() data:any): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.create(data);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllMechinesRequisitionData')
    async getAllMechinesRequisitionData(): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.getAllMechinesRequisitionData()
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getMechinesRequisitionDataByPONOs')
    async getMechinesRequisitionDataByPONOs(@Body() req:machinesRequisitionIdReq): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.getMechinesRequisitionDataByPONOs(req)
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/createSnap')
    async createSnap(@Body() data:any): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.createSnap(data);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllMechinesRequisitionSnapData')
    async getAllMechinesRequisitionSnapData(): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.getAllMechinesRequisitionSnapData()
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/getMechinesRequisitionSnapDataByPoNos')
    async getMechinesRequisitionSnapDataByPoNos(@Body() req:machinesRequisitionIdReq): Promise<CommonResponse> {
        try {
            return await this.machinesReqService.getMechinesRequisitionSnapDataByPoNos(req)
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
}